export default __webpack_public_path__ + "static/media/kone-logo-white.1ecf9618.svg";